import { cn } from '@lashpic/ui/utils';
import { Home, Images, Sparkles, User } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const tabs = [
  { to: '/home', icon: Home, label: '홈' },
  { to: '/studio/source', icon: Sparkles, label: '스튜디오' },
  { to: '/gallery', icon: Images, label: '갤러리' },
  { to: '/me', icon: User, label: '나' },
] as const;

export function BottomTabBar() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 border-t border-[var(--color-border)] bg-white/65 backdrop-blur-xl backdrop-saturate-150 md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="mx-auto flex h-16 max-w-[430px] items-center justify-around px-2">
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <li key={t.to} className="flex-1">
              <NavLink
                to={t.to}
                className={({ isActive }) =>
                  cn(
                    'relative flex flex-col items-center gap-1 py-2 text-[11px] transition-colors',
                    isActive
                      ? 'font-semibold text-[var(--color-lavender-600)]'
                      : 'text-[var(--color-muted-foreground)]',
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    {isActive && (
                      <span className="absolute top-0 h-0.5 w-8 rounded-full bg-[var(--color-lavender-500)]" />
                    )}
                    <Icon className="h-5 w-5" />
                    <span>{t.label}</span>
                  </>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
